webpackJsonp([226007831995069],{

/***/ 523:
/***/ (function(module, exports) {

	module.exports = {"data":{"site":{"siteMetadata":{"title":"Mitchell Kansas Tesla Blog","author":"Ryan Mitchell"}},"markdownRemark":{"id":"/opt/build/repo/src/pages/2018-06-18-brynn-1/index.md absPath of file >>> MarkdownRemark","html":"<p>Hello, I am “THE DAUGHTER”. I live in Austin, TX</p>\n<p>We’re getting our things in the car, working out divices and making the final deciciens\non our routes.</p>\n<p>Fainally, after forgetting to charge my nintendo and forgetting to get\na trash can, we got on the road.</p>","frontmatter":{"title":"Hello!","date":"June 16, 2018","author":"brynn"}}},"pathContext":{"slug":"/2018-06-18-brynn-1/","previous":{"fields":{"slug":"/2018-06-24-delia-posts/index-2/"},"frontmatter":{"title":"On The Road","author":"delia"}},"next":{"fields":{"slug":"/2018-06-18-kian-update-1/"},"frontmatter":{"title":"Intro","author":"kian"}}}}

/***/ })

});


// WEBPACK FOOTER //
// path---2018-06-18-brynn-1-1cde288b36f5db5f9384.js